import { apiSlice } from "../apiSlice";
import { STUDENTQUESTIONS_URL } from "../../constants";

export const questionsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        newQuestion: builder.mutation({
            query: (data) => ({
                url: `${STUDENTQUESTIONS_URL}/newquestion`,
                 method: 'POST',
                    body: data,
            }),
        }),
        getStudentNewAnswers: builder.query({
            query: ({ pageNumber }) => ({
                url: `${STUDENTQUESTIONS_URL}/newstudentanswers`,
                params: {
                    pageNumber,
                },
            }),
            providesTags: ['Answers'], 
        }),
        getStudentNewAnswer: builder.query({
            query: (id) => ({
                url: `${STUDENTQUESTIONS_URL}/newstudentanswer/${id}`,
            }),
        }),
        getStudentQuestion: builder.query({
            query: (id) => ({
                url: `${STUDENTQUESTIONS_URL}/getstudentquestion/${id}`,
            }),
        }),
        getStudentAllQuestions: builder.query({
            query: (id) => ({
                url: `${STUDENTQUESTIONS_URL}/studentallquestions/${id}`,
            }),
        }),
        getStudentAllAnswers: builder.query({
            query: (id) => ({
                url: `${STUDENTQUESTIONS_URL}/studentallanswers/${id}`,
            }),
        }),
        updateAnswerWatched: builder.mutation({
            query: (id) => ({
                url: `${STUDENTQUESTIONS_URL}/updateanswerwatched/${id}`,
                 method: 'PUT',
            }),
            invalidatesTags: ['Answers'], // Invalidate 'Answers' cache upon success
        }),
    }),
});

export const { useNewQuestionMutation, useUpdateAnswerWatchedMutation, useGetStudentNewAnswersQuery, useGetStudentNewAnswerQuery, useGetStudentAllQuestionsQuery, useGetStudentAllAnswersQuery, useGetStudentQuestionQuery  } = questionsApiSlice;




                            
